import { showError } from "./alerts"
import { TOKEN_ERROR } from "./auth";

export const handleApiError = (error) => (dispatch) => {
    if (error.response.status) {
      const { status } = error.response;
      if (status === 401 || status === 403 || status === 404) {
        dispatch({ type: TOKEN_ERROR })
        dispatch(showError("Authentication expired. Please login."))
      } else if (status >= 460 && status < 500) {
          dispatch(showError(error.response.data))
      }
    } else {
      dispatch(showError(error.response))
    }
}
